<template>
  <v-container fluid>

    <div id="hero" class="d-flex flex-column align-center justify-center px-4">
      <img :src="logoImg" alt="" width="300" />
      <p class="text-center mt-4">
        Be Purposeful. <br />
        Take Control of Your Life. <br />
        Do the Simple Things Excellently.
      </p>
    </div>


    <v-row v-if="showLogin"
      id="user-form"
      class="justify-center my-8"
    >
      <LoginForm />
    </v-row>
<!--    <v-row v-else-->
<!--      id="user-form" class="justify-center"-->
<!--    >-->
<!--      <SignupForm />-->
<!--    </v-row>-->


  </v-container>
</template>

<script>
import LogoImg from '@/assets/logo-full.png';
import LoginForm from './LoginForm.vue';
// import SignupForm from './SignupForm.vue';
import { isUserLoggedIn } from "@/services/UserServices";



export default {
  components: {
    LoginForm,
    // SignupForm,
  },
  props: ['view'], 
  data() {
    return {
      logoImg: LogoImg,
      showLogin: true, // by default, show the login form (not signup form)
    };
  },
  /** DISABLING SIGNUP FOR NOW 2025-10-15 */
  // methods: {
  //   // toggleView(view) {
  //   //   this.showLogin = view !== 'signup'; // showLogin will be true, unless == 'signup'
  //   // }
  // },
  created() {

    if (isUserLoggedIn()) {
      this.$router.replace('/dash');
    }
    // else if (this.view) {
    //   this.toggleView(this.view);
    // }

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },
  /** DISABLING SIGNUP FOR NOW 2025-10-15 */
  // updated() {
  //   // if (this.view) {
  //   //   this.toggleView(this.view);
  //   // }
  // },
}
</script>

<!--<style scoped>-->
<!--.v-card {-->
<!--  max-width: 400px !important;-->
<!--}-->
<!--</style>-->
